Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var Component = require('../Component.js');
var components_content_Component = require('../components/content/Component.js');
var components_controls_Component = require('../components/controls/Component.js');
var components_footer_Component = require('../components/footer/Component.js');
var components_header_Component = require('../components/header/Component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var ModalMobileComponent = React.forwardRef(function (props, ref) { return (React__default.default.createElement(Component.Modal, tslib.__assign({}, props, { ref: ref, view: 'mobile' }))); });
var ModalMobile = Object.assign(ModalMobileComponent, {
    Content: components_content_Component.Content,
    Header: components_header_Component.Header,
    Footer: components_footer_Component.Footer,
    Controls: components_controls_Component.Controls,
});

exports.ModalMobile = ModalMobile;
